import React from 'react';
import useCareerLogic from './CareerLogic';
import CareerView from './CareerView';

const Career = () => {
  // שימוש בלוגיקה
  const careerLogic = useCareerLogic();
  
  // העברת נתונים לתצוגה
  return <CareerView />;
};

export default Career; 